/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';

import { Modal, Card, Table, message, Form, Button, Typography } from "antd";
import { Row, Col, Space, Spin, Flex } from "antd";
import { Input } from "antd";
import { BankTwoTone, SearchOutlined } from "@ant-design/icons";
import { useForm } from 'antd/es/form/Form';
 
import { columns } from "./modal-treatment.model";
import { BsUiChecks } from "react-icons/bs"; 

import ModalTreatmentManage from './ModalTreatmentManage';
// import OptionService from '../../../service/Options.service';
import TreatmentService from "../../../service/Treatment.service.js";
import "./modal-treatment.css";
// const optionService = OptionService();
const tmservice = TreatmentService();
const mngConfig = {title:"", textOk:null, textCancel:null, action:"create", code:null};
export default function ModalTreatment({show, close, values}) {
    const [form] = useForm();
    const inputRef = useRef(null);
    const [modalData, setModalData] = useState([]);
    const [modalDataWrap, setModalDataWrap] = useState([]);

    const [openModal,  setOpenModel] = useState(show);
    const [loading,  setLoading] = useState(true);

    const [rowKeySelect, setRowKeySelect] = useState([]); 

    const [openManage, setOpenManage] = useState(false)
    const [config, setConfig] = useState(mngConfig);
    // console.log( itemsTypeData )

    /** handle logic component */
    const handleClose = () =>{ 
        setTimeout( () => { close(false);  }, 140);
        
        //setTimeout( () => close(false), 200 );
    }

    const handleSearch = (value) => {  
        const input =  value?.toLowerCase();
        if(!!value){    
            const f = modalData.filter( d => {
                const text = ( 
                    d.acc_no?.toLowerCase()?.includes(input) || 
                    d.bank_name?.toLowerCase()?.includes(input) || 
                    d.bank_name_th?.toLowerCase()?.includes(input) ||
                    d.acc_name?.toLowerCase()?.includes(input)
                );
                return  text;
            });
            setModalDataWrap(f);
        }  else setModalDataWrap(modalData); 
    }

    const handleChoose = (v) => {
        // const choosed = selected.map( m => m.acc_no );
        // console.log(v.tm_code);
        let itemsChoose = [];
        tmservice.getdetail(v.tm_code).then( res => {
            itemsChoose = Object.values(res.data).map( m => ({
                status: 'process',
                title: m.step_name,
                // disabled: true,
            }));
        })
        .catch( err => {
            message.error("Request error!");
        })
        .finally( () => {
            // console.log(itemsChoose);
            values(itemsChoose);
            setOpenModel(false);
        });

            // console.log(data);
        // const itemsChoose = v.map( (m, i) => ({
        //     status: 'process',
        //     title: m,
        //     disabled: true,
        //   }));
        
        // const itemsChoose = [
        //   {
        //     status: 'finish',
        //     title: 'finish 1',
        //     disabled: true,
        //   },
        //   {
        //     status: 'finish',
        //     title: 'finish 2',
        //     disabled: true,
        //   },
        //   {
        //     status: 'process',
        //     title: 'current process',
        //     disabled: true,
        //   },
        //   {
        //     status: 'wait',
        //     title: 'wait',
        //     disabled: true,
        //   },
        // ]
        // values([...itemsChoose]);
        
        // setOpenModel(false);
    }

    /** setting initial component */ 
    const column = columns({ handleChoose });
    const onload = () =>{
        setLoading(true);
        tmservice.search({}, { ignoreLoading : true }).then(async (res) => {
            let { data } = res.data; 
            setModalData(data);
            setModalDataWrap(data);
        })
        .catch((err) => { 
            message.error("Request error!");

            // setLoading(false);
        })
        .finally( () => setTimeout( () => { setLoading(false); }, 400));
    }  
    useEffect( () => {
      
        if( !!openModal ){
            onload(); 
            // console.log("modal-packages")        
        } 
    }, [openModal]);


    /** setting child component */
    const ButtonManageModal = (
        <Row gutter={[{xs:32, sm:32, md:32, lg:12, xl:12}, 8]} className='m-0'>
            <Col span={24}>
                <Typography.Link onClick={()=>{ 
                    setConfig({...mngConfig, title:"Create Treatment & Processing", action:"create"})
                    setOpenManage(true); 
                }} className='ps-1'>
                    <span className='hover:underline underline-offset-1'>Create Treatment & Processing</span>
                </Typography.Link> 
            </Col>
        </Row>   
    )
    /** */

    return (
        <>
        <Modal
            open={openModal}
            title={<><Typography.Text className='ms-1 mb-0'>Treatment & Processing</Typography.Text></>}
            afterClose={() => handleClose() }
            onCancel={() => setOpenModel(false) } 
            maskClosable={false}
            style={{ top: 20 }}
            width={800}
            className='modal-customers'
            footer={(
                <Row>
                    <Col span={24}>
                        {/* Ignore */}
                    </Col>
                    <Col span={24}>
                        <Flex justify='flex-end'>
                            <Button  className='bn-center bn-primary' icon={<BsUiChecks />} onClick={()=>handleChoose()}> Confirm </Button>
                        </Flex>
                    </Col> 
                </Row>
            )}
        >
            <Spin spinning={loading} >
                <Space direction="vertical" size="middle" style={{ display: 'flex', position: 'relative'}}  >
                    <Card style={{backgroundColor:'#f0f0f0' }}>
                        <Form form={form} layout="vertical" autoComplete="off" >
                            <Row gutter={[{xs:32, sm:32, md:32, lg:12, xl:12}, 8]} className='m-0'>
                                <Col span={24}>
                                    <Form.Item label="ค้นหา"  >
                                        <Input ref={inputRef} suffix={<SearchOutlined />} onChange={ (e) => { handleSearch(e.target.value) } } placeholder='ค้นหาชื่อ หรือ รหัส'/>
                                    </Form.Item>                        
                                </Col> 
                            </Row>
                            { ButtonManageModal }
                        </Form>
                    </Card>
                    <Card style={{minHeight:'60vh'}}>
                        <Table
                            // bordered={false}
                            dataSource={modalDataWrap}
                            // rowSelection={itemSelection}
                            columns={column}
                            rowKey="acc_no"
                            pagination={{ 
                                total:modalDataWrap?.length || 0, 
                                showTotal:(_, range) => `${range[0]}-${range[1]} of ${modalDataWrap?.length || 0} items`,
                                defaultPageSize:25,
                                pageSizeOptions:[25,35,50,100]
                            }} 
                            size='small'
                        /> 
                    </Card>
                </Space>  
                { openManage && 
                    <ModalTreatmentManage 
                        config={config}
                        open={openManage} 
                        close={()=>setOpenManage(false)} 
                        complete={() => { onload(); setOpenManage(false); }} 
                    />
                }                  
            </Spin>
        </Modal>    
        </>
    )
}